import type { HeyGenDimension } from '../../../types/avatar-video';

export type AvatarsOrientation = 'wide' | 'vertical';

/**
 * Deriva la orientación a partir de una `HeyGenDimension`. Usa el discriminator
 * literal de la union (1920×1080 → wide, 1080×1920 → vertical).
 *
 * El check `never` final fuerza un error de TypeScript si se agrega una nueva
 * variante a `HeyGenDimension` (ej. cuadrado 1080×1080) sin actualizar esta
 * función. Eso garantiza que cualquier consumidor (placas, layouts, etc.)
 * cubra los casos nuevos cuando se introduzcan.
 */
export const getAvatarsOrientation = (dimension: HeyGenDimension): AvatarsOrientation => {
  if (dimension.width === 1920 && dimension.height === 1080) return 'wide';
  if (dimension.width === 1080 && dimension.height === 1920) return 'vertical';
  const _exhaustive: never = dimension;
  throw new Error(`HeyGenDimension no soportada: ${JSON.stringify(_exhaustive)}`);
};
